import React from 'react';
import styled from 'styled-components/macro';
import InputBase from '../form/InputBase';
import { InputAdornment } from '@material-ui/core';
import Button from '../Button';
import useTranslations from '../../hooks/useTranslations';
import Colors from '../../internal-components/Colors';
import GroupsAndUsersInputBoxEngine from '../engine/GroupsAndUsersInputBoxEngine';
import FormBuilderSharePermissionsEngine from '../engine/FormBuilderSharePermissionsEngine';
import _LinkIcon from '@material-ui/icons/Link';
import { SimpleFlexContainer } from '../layouts/ng-layouts/Containers';
import FormBuilderShareEmailSettingsEngine from '../engine/FormBuilderShareEmailSettingsEngine';
import FormBuilderCustomizationEngine from '../engine/FormBuilderCustomizationEngine';
import FormBuilderAccessSettingEngine from '../engine/FormBuilderAccessSettingEngine';

export const Container = styled.div`
  background: #fff;
  width: 1060px;
  height: 100%;
  margin: 20px auto 0;

  display: flex;
  flex-direction: column;
`;

const FlexBlock = styled(SimpleFlexContainer)`
  padding: 0.8rem;
  border-bottom: 1.5rem solid ${Colors.BACKGROUND_GREY};
`;

export const DisableWrapper = styled(SimpleFlexContainer)`
  ${({ $disabled }) => $disabled && `opacity: 0.4; pointer-events:none;`}
`;

const H2 = styled.h2`
  margin: 0.8rem 0 1.2rem;
  font-size: 18px;
  ${({ $hasSubText }) => $hasSubText && 'margin-bottom: 0.4rem;'}
`;

const TitleSubText = styled.small`
  margin-bottom: 0.8rem;
`;

const LinkIcon = styled(_LinkIcon)`
  && {
    transform: rotate(45deg);
  }
`;

const SpecialSpacer = styled.div`
  margin: 2rem 0;
`;

const FormBuilderShareView = props => {
  const t = useTranslations();

  return (
    <Container>
      <FlexBlock>
        {/************ [Share Link] ************/}
        <H2>{t('form-builder.share.link.title')}</H2>
        <InputBase
          readOnly
          inputRef={props.linkRef}
          value={`${props.tenantURL}/forms/assigned/${props.formId}`}
          data-testid="share-link"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button
                  size="small"
                  onClick={props.onLinkCopy}
                  data-testid="share-link-copy-button"
                  customCSS={'height: 27px; font-size: 12px;'}
                  startIcon={<LinkIcon />}
                >
                  Copy
                </Button>
              </InputAdornment>
            )
          }}
        />
        {/************ [Access Settings] ************/}
        <FormBuilderAccessSettingEngine />
      </FlexBlock>
      <FlexBlock>
        {/************ [Send via Email] ************/}
        <DisableWrapper $disabled={props.isPublic}>
          {/* <SpecialSpacer /> */}
          <H2 $hasSubText>{t('form-builder.share.send-via-email.title')}</H2>
          <TitleSubText>
            {t('form-builder.share.send-via-email.description')}
          </TitleSubText>
          <GroupsAndUsersInputBoxEngine />
        </DisableWrapper>
      </FlexBlock>
      <FlexBlock>
        {/************ [Permissions] ************/}
        <H2>{t('form-builder.users.limit_permissions_title')}</H2>
        <FormBuilderSharePermissionsEngine />
      </FlexBlock>
      <FlexBlock>
        {/************ [Customization] ************/}
        <H2 $hasSubText>{t('form-builder.users.customization.title')}</H2>
        <TitleSubText>
          {t('form-builder.users.customization.label')}
        </TitleSubText>
        <FormBuilderCustomizationEngine />
      </FlexBlock>
      <FlexBlock>
        {/************ [Email Settings] ************/}
        <H2 $hasSubText>{t('form-builder.users.email_settings.title')}</H2>
        <TitleSubText>
          {t('form-builder.users.email_settings.label')}
        </TitleSubText>
        <FormBuilderShareEmailSettingsEngine formId={props.formId} />
      </FlexBlock>
    </Container>
  );
};

export default FormBuilderShareView;
